export default function WhoIsThisProductFor() {
    return {
        title: 'Who is this Product for?',
        paragraphs: [
            `<div>Review your book of business for opportunities:<div>
            <ul class="mt-2"><li class="pl-2">Clients at all life stages</li>
            <li class="pl-2">At-risk and off-track clients in Goals Planning System</li>
            <li class="pl-2">Are Over age 25</li>
            <li class="pl-2">Have estate or business planning needs</li>
            <li class="pl-2">Have a temporary need for increased coverage</li>
            <li class="pl-2">Have children or other dependents who rely on their income to maintain their lifestyle</li>
            <li class="pl-2">Are looking for pure death benefit protection</li></ul>
            <div>Conversation Starters:</div>
            <ul class="mt-2 mb-0"><li class="pl-2">What provisions has the client made to ensure the family can maintain their current lifestyle?</li>
            <li class="pl-2">Is there enough life insurance to replace increased income since the last evaluation?</li>
            <li class="pl-2">How will your family cover your mortgage payments in the event that the primary or secondary wage earner passes away?</li>
            <li class="pl-2">How will your family cover your other personal debts in the event that the primary or secondary wage earner passes away?</li>
            <li class="pl-2">How is the client insuring that their children/grandchildren have the savings necessary to afford a college education?</li>
            <li class="pl-2">Is your buy/sell plan funded?</li></ul>`
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/term/WhoIsThisProductData.js